export default __webpack_public_path__ + "static/media/test8.e2647c15.png";